import { colors } from '@zet/design-system'
import RadioOff from '@zet/design-system/svg/RadioOff'
import RadioOn from '@zet/design-system/svg/RadioOn'
import { useUnsafeVariable } from 'nativewind'

const RadioButton = ({
  isChecked = false,
  //   onPress,
  size = 12,
}: {
  isChecked?: boolean
  //   onPress?: () => void
  size?: number
}) => {
  const [colorPrimary100] = useUnsafeVariable('--color-primary-100')

  if (isChecked) {
    return <RadioOn size={size} color={colorPrimary100} />
  }

  return <RadioOff size={size} color={colors.grays[50]} />
}

export default RadioButton
